var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCocosIsland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#6DA544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5616 22.9563L25.0007 23.8744L25.9922 23.6452L25.5482 24.5609L26.3455 25.1932L25.3528 25.4169L25.3556 26.4346L24.5616 25.7979L23.7678 26.4346L23.7705 25.4169L22.7778 25.1932L23.5751 24.5609L23.1311 23.6452L24.1226 23.8744L24.5616 22.9563Z",
    fill: "#FFDA44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4772 13.2173L20.9163 14.1354L21.9078 13.9062L21.4637 14.822L22.261 15.4542L21.2684 15.678L21.2711 16.6956L20.4772 16.059L19.6833 16.6956L19.686 15.678L18.6934 15.4542L19.4907 14.822L19.0466 13.9062L20.0382 14.1354L20.4772 13.2173Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5617 7.65213L25.0008 8.57019L25.9923 8.34094L25.5483 9.25669L26.3456 9.88901L25.3528 10.1127L25.3555 11.1304L24.5617 10.4937L23.7678 11.1304L23.7706 10.1127L22.778 9.88901L23.5752 9.25669L23.1312 8.34094L24.1226 8.57019L24.5617 7.65213Z",
    fill: "#FFDA44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1294 11.8258L28.5685 12.7438L29.56 12.5147L29.116 13.4304L29.9133 14.0627L28.9206 14.2864L28.9233 15.3041L28.1294 14.6674L27.3355 15.3041L27.3382 14.2864L26.3456 14.0627L27.1429 13.4304L26.6988 12.5147L27.6903 12.7438L28.1294 11.8258Z",
    fill: "#FFDA44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5779 16.6957L25.9233 17.7587H27.0409L26.1367 18.4156L26.4821 19.4784L25.5779 18.8216L24.6738 19.4784L25.0191 18.4156L24.115 17.7587H25.2326L25.5779 16.6957Z",
    fill: "#FFDA44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7392 20.5217C15.2419 20.5217 13.2174 18.4972 13.2174 15.9999C13.2174 13.5027 15.2418 11.4782 17.7392 11.4782C18.5178 11.4782 19.2505 11.6751 19.8901 12.0217C18.8867 11.0403 17.5145 10.4347 15.9999 10.4347C12.9264 10.4347 10.4348 12.9263 10.4348 15.9999C10.4348 19.0734 12.9264 21.5651 15.9999 21.5651C17.5144 21.5651 18.8867 20.9594 19.8901 19.9781C19.2505 20.3248 18.5178 20.5217 17.7392 20.5217V20.5217Z",
    fill: "#FFDA44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0614 6.26079C9.58018 5.42929 8.68174 4.86948 7.65199 4.86948C6.62224 4.86948 5.7238 5.42929 5.24255 6.26079H10.0614Z",
    fill: "#FFDA44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0709 6.27679L7.65219 8.69548L5.2335 6.27679C5.00232 6.68248 4.86963 7.15167 4.86963 7.65204C4.86963 9.18886 6.11544 10.4347 7.65225 10.4347C9.18907 10.4347 10.4349 9.18892 10.4349 7.65204C10.4348 7.15167 10.3021 6.68248 10.0709 6.27679V6.27679Z",
    fill: "#FFDA44"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9563 8V10.3471C7.17861 10.4043 7.41174 10.4347 7.65192 10.4347C7.89211 10.4347 8.12524 10.4043 8.34755 10.3471V8H6.9563Z",
    fill: "#A2001D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCocosIsland);
export default __webpack_public_path__ + "static/media/cocos-island.b5a6c21c.svg";
export { ForwardRef as ReactComponent };